import { call, put, select } from 'typed-redux-saga';

import { SSHelper } from '@crm-package/utils';

import { chatActions, getChatState, storageKeySelector } from '../store';
import { IStorageToken } from '../types';

import { getClientToken } from './api';

export function* getToken(clientId?: number) {
  const token = SSHelper.getObject<IStorageToken>(storageKeySelector(clientId));
  const { isClientUnAuthorized } = yield* select(getChatState);
  const currentTime = new Date().getTime() / 1000;

  if (token) {
    if (currentTime < token.expiresIn!) {
      if (clientId && !isClientUnAuthorized) {
        yield put(chatActions.clientUnAuthorized({ isAuthorized: true }));
      }

      return token.token;
    }
  } else {
    try {
      const { token: serverToken, errorStatus } = yield* call(
        getClientToken,
        clientId
      );

      if (serverToken) {
        if (!isClientUnAuthorized) {
          yield put(chatActions.clientUnAuthorized({ isAuthorized: true }));
        }

        return serverToken;
      }

      switch (errorStatus) {
        case 'XCHAT_DISABLED_ON_BRAND':
        case 'XCHAT_INVALID_CLIENT_ID':
          yield put(chatActions.clientUnAuthorized({ isAuthorized: false }));
          break;
        case 'XCHAT_DISABLED_ON_INSTANCE':
          yield put(chatActions.disable());
          break;
      }
    } catch (e) {
      if (clientId) {
        yield put(chatActions.clientUnAuthorized({ isAuthorized: false }));
      } else {
        yield put(chatActions.disable());
      }
    }
  }

  return undefined;
}
